export default __webpack_public_path__ + "static/media/Hero's Chestguard.226f66af.jpg";